<template>
  <div class="card">
    <div class="card-header d-flex align-items-center justify-content-between mobile-card-header">
      <div>
        <h4 class="card-title">Editing {{ profile_type | capitalize }} Profile
        </h4>
      </div>
      <div>
        <a class="btn btn-outline-danger" :href="page_url">Cancel</a>
        <button @click="saveUser" name="button" type="submit" class="btn btn-primary" :disabled="user.locked">
          <i v-if="saving" class="fa fa-spinner-third fa-spin mr-2"></i>
          Save
        </button>
      </div>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-6">
          <!-- Non Donor & Beneficiary Profile -->
           <div v-if="!this.hasImportID">
            <div v-if="allowedField('first_name')" class="form-group">
              <label for="first_name">First Name</label>
              <input v-model="user.first_name" id="user_first_name" class="form-control" placeholder="First Name" type="text">
            </div>
          </div>

          <!-- Donor & Beneficiary Profile but can't view import id -->
          <div v-if="this.hasImportID && !this.showImportID">
            <div v-if="allowedField('first_name')" class="form-group">
              <label for="first_name">First Name</label>
              <input v-model="user.first_name" id="user_first_name" class="form-control" placeholder="First Name" type="text">
            </div>
          </div>

          <!-- Donor & Beneficiary Profile and can view import id -->
          <div v-if="this.hasImportID && this.showImportID">
            <div v-if="allowedField('first_name')" class="form-group">
              <label for="first_name">First Name</label>
              <div class='input-group'>
                <input v-model="user.first_name" id="user_first_name" class="form-control" placeholder="First Name" type="text">
                <div class="input-group-append">
                  <button class="btn btn-light btn-border" type="button" @click="copyImportID(user.import_id)">{{ user.import_id }}</button>
                </div>
              </div>
              <small class="form-text text-muted">
                The number attached to the side of this field is the unique <b>Import ID</b> of this user.
              </small>
            </div>
          </div>

          <div v-if="allowedField('last_name')" class="form-group">
            <label for="last_name">Last Name</label>
            <input v-model="user.last_name" id="user_last_name" class="form-control" placeholder="Last Name" type="text">
          </div>

          <div v-if="user.user_type == 'donor' || user.user_type == 'beneficiary'">
            <div v-if="allowedField('email')" class="form-group">
              <label for="email">Email</label>
              <div class='input-group'>
                <input v-model="user.email" id="user_email" name="email" class="form-control" placeholder="Example@domain.com" type="email">
                <div class="input-group-append">
                  <button class="btn btn-light btn-border" type="button" @click="openAdditionalEmails()">Others</button>
                </div>
              </div>
              <small class="form-text text-muted">
                Click the <b>Others</b> button to add additional emails and set as default for notifications
              </small>
            </div>
          </div>

          <div v-if="user.user_type !== 'donor' && user.user_type !== 'beneficiary'">
            <div v-if="allowedField('email')" class="form-group">
              <label for="email">Email</label>
              <input v-model="user.email" id="user_email" name="email" class="form-control" placeholder="Example@domain.com" type="email">
            </div>
          </div>

          <div v-if="allowedField('username')" class="form-group">
            <label for="username">Username</label>
            <input v-model="user.username" id="user_username" class="form-control" placeholder="Username">
            <small class="form-text text-muted">Will be used for login when feature available.</small>
          </div>
          </div>

        <div class="col-md-6">
          <div class="form-group" :style="{ paddingBottom: '5px' }">
            <label>Profile Image</label>
            <div class="d-flex">
              <div class="mr-3">
                <avatar :src="user.avatar_url" :fallback="user.name" />
              </div>
              <div>
                <uploader @file-upload="setAvatarImage"/>
              </div>
            </div>
          </div>
          <div class="form-group" :style="{ paddingBottom: '5px' }">
            <label>Receive Email Updates</label>
            <div class="form-check">
              <label class="form-check-label">
                <input class="form-check-input" type="checkbox" v-model="user.subscribed_to_notifications">
                <span class="form-check-sign">Keep me updated</span>
              </label>
            </div>
          </div>
          <div v-if="user.user_type == 'donor' || user.user_type == 'beneficiary'">
            <div class="form-group" :style="{ paddingBottom: '5px' }">
              <label>Notify of Field Changes</label>
              <div class="form-check">
                <label class="form-check-label">
                  <input class="form-check-input" type="checkbox" v-model="user.notify_of_field_changes">
                  <span class="form-check-sign">Keep me updated</span>
                </label>
              </div>
            </div>
          </div>
          <div v-if="user.user_type == 'beneficiary'">
            <div class="form-group" :style="{ paddingBottom: '5px' }">
              <label>Profile Video</label>
              <div class="form-check">
                <label class="form-check-label">
                  <input
                    class="form-check-input" type="checkbox"
                    v-model="user.add_youtube_video"
                    :disabled="restrictUser()"
                  >
                  <span class="form-check-sign">Add video to profile</span>
                </label>
              </div>
            </div>

              <div v-if="user.add_youtube_video" class="form-group">
                <label for="video">YouTube Video Link</label>
                <input
                  v-model="user.video_url" id="user_video"
                  class="form-control" placeholder="Paste The Video URL"
                  :disabled="restrictUser()"
                >
                <small class="form-text text-muted">Click share on the YouTube video to get link</small>
              </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div v-if="allowedField('birthday')" class="form-group">
            <label for="birthday">Birthday</label>
            <flat-pickr v-model="user.birthday" class="form-control"></flat-pickr>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div v-if="allowedField('bio')" class="form-group">
            <label for="bio">Bio</label>
            <textarea v-auto-expand v-model="user.bio" class="form-control"></textarea>
          </div>
        </div>
      </div>

      <div class="row">
        <div v-for="custom_field in user.custom_field_values" :key="custom_field.id" class="col-md-12">
          <div v-if="allowedCustomField(custom_field)" class="form-group">
            <label :for="custom_field.name">{{ custom_field.name }}</label>
            <template v-if="custom_field.value_type == 'text' || custom_field.value_type == 'link'">
              <input v-model="custom_field.value" class="form-control">
            </template>
            <template v-if="custom_field.value_type == 'date'">
              <flat-pickr v-model="custom_field.value" class="form-control"></flat-pickr>
            </template>
            <template v-if="custom_field.value_type == 'long_text'">
              <textarea v-auto-expand v-model="custom_field.value" class="form-control"></textarea>
            </template>
            <template v-if="custom_field.value_type == 'select'">
              <select v-model="custom_field.value" class="form-control">
                <option v-for="option in custom_field.select_options" :value="option">{{ option }}</option>
              </select>
            </template>
            <template v-if="custom_field.value_type == 'dynamic'">
              <div class="input-group">
                <input 
                  class="form-control" 
                  placeholder="Read only, click edit button to edit and create new values"
                  type="text"
                  :value="custom_field.value"
                  disabled
                />
                <div class="input-group-append">
                    <button class="btn btn-light btn-border" type="button" @click="editModal(custom_field)">Edit</button>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>

    <DynamicFieldModal v-if="isEditing" :field_values="field" :close="closeEditModal" />
    <AdditionalEmailsModal v-if="openedAdditionalEmails" :emails="emails" :close="closeEmailModal" />
  </div>
</template>
<script>
import { HTTP } from "../api/resources";
import Uploader from "./Uploader/Uploader";
import Avatar from "./Avatar/Avatar";
import DynamicFieldModal from "./Helpers/Modal/Forms/Vue/DynamicFieldModal";
import AdditionalEmailsModal from "./Helpers/Modal/Forms/Vue/AdditionalEmailsModal";
export default {

  props: ['profile', 'profile_type', 'resource_url', 'custom_fields', 'page_url', 'current_user'],

  components: {
    Uploader,
    Avatar,
    DynamicFieldModal,
    AdditionalEmailsModal
  },

  data() {
    return {
      saving: false,
      showing_details:  false,
      user: {}, 
      isEditing: false,
      field: null,
      fieldInfo: null,
      emails: [],
      openedAdditionalEmails: false,
      hasImportID: this.profile.user_type == 'donor' || this.profile.user_type == 'beneficiary',
      showImportID: this.current_user.user_type !== 'donor' && this.current_user.user_type !== 'beneficiary'
    }
  },

  created() {
    this.user = _.cloneDeep(this.profile);
    const userRestricted = this.user.user_type != 'manager' && this.user.user_type != 'assistant_manager'
  },

  methods: {
    setAvatarImage(blob) {
      this.user.avatar = blob.signed_id;
      this.user.avatar_url = blob.cdn_url;
    },

    invalidInput() {
      if (this.user.add_youtube_video && !this.user.video_url) {
        Alert.show('notice', 'YouTube video link is a required field when add video to profile is checked')
        return true
      }

      if ((!this.user.email || this.user.email.length < 1) && this.user.additional_emails && this.user.additional_emails.length > 0) {
        Alert.show('notice', 'Primary email is required to set additional emails')
        return true
      }

      return false
    },

    saveUser() {
      if (this.invalidInput()) return

      const self = this;
      this.saving = true;
      HTTP.patch(`${this.resource_url}/${this.user.id}.json`, { user: this.user }).then(response => {
          this.saving = false;
          Alert.show('notice', 'Profile saved!');
          setTimeout(() => {
            window.location.reload();
          }, 1500);
        }).catch(e => {
          this.saving = false;
          Alert.show('error', 'Profile not saved! Try again or refresh.');
        })
    },

    allowedField(field) {
      if (window.clarity.cu.type == 'manager' || window.clarity.cu.type == 'assistant_manager') {
        return true
      }
      const self = this;
      let f = _.find(self.custom_fields, (uf) => uf.system_key == field)
      if (f && !f.editable) {
        return false;
      }
      return true;
    },

    allowedCustomField(custom_field) {
      if (window.clarity.cu.type == 'manager' || window.clarity.cu.type == 'assistant_manager') {
        return true
      }
      return custom_field.editable;
    },

    restrictUser() {
      if (window.clarity.cu.type == 'manager' || window.clarity.cu.type == 'assistant_manager') {
        return false
      } else {
        return true
      }
    },

    editModal(custom_field) {
      this.isEditing = true 
      this.field = custom_field.dynamic_value
      this.fieldInfo = custom_field
    },

    closeEditModal(values) {
      this.isEditing = false
      this.field = null

      const fieldIndex = this.user.custom_field_values.findIndex(field => field.id === this.fieldInfo.id);
      if (fieldIndex !== -1) {
        this.user.custom_field_values[fieldIndex].dynamic_value = values;
      }
    },

    closeEmailModal(values){
      this.openedAdditionalEmails = false
      this.emails = values
      this.user.additional_emails = values
    },

    openAdditionalEmails() {
      this.openedAdditionalEmails = true
      this.emails = this.user.additional_emails
    },

    copyImportID(id) {
      navigator.clipboard.writeText(id)
      Alert.show('notice', 'Copied Import ID to clipboard')
    }
  }
}
</script>
